import { render, staticRenderFns } from "./SourceButton.vue?vue&type=template&id=8caa3088&"
import script from "./SourceButton.vue?vue&type=script&lang=js&"
export * from "./SourceButton.vue?vue&type=script&lang=js&"
import style0 from "./SourceButton.vue?vue&type=style&index=0&id=8caa3088&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports